const getAssetUrl = (assets, locale, assetLink) => {
    if (!assetLink)
        return "";
    const assetUrl = assets[assetLink.sys.id]?.fields.file[locale]?.url;
    if (assetUrl) {
        return assetUrl.startsWith("https:") || assetUrl.startsWith("http:")
            ? assetUrl
            : `https:${assetUrl}`;
    }
    return "";
};
export { getAssetUrl };
//# sourceMappingURL=contentful.js.map